import { ApiResult, request, safeRequest } from '@synergy/api';

import {
    ExternalCustomerMappingFullResponse,
    ExternalCustomerMappingUpdateRequest,
} from '../../../../components/external-customer-mapping/external-customer-mapping';

export class SupplierExternalCustomerMappingApi {
    constructor(protected baseUrl: string) {}

    public getExternalCustomerMappings(supplierId: number): Promise<ApiResult<ExternalCustomerMappingFullResponse[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/suppliers/${supplierId}/external-customer-mappings`),
            response => response.data
        );
    }

    public updateExternalCustomerMappings(
        supplierId: number,
        externalCustomerMappings: ExternalCustomerMappingUpdateRequest[]
    ): Promise<ApiResult<ExternalCustomerMappingFullResponse[]>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/suppliers/${supplierId}/external-customer-mappings/update`, {
                    externalCustomerMappings,
                }),
            response => response.data
        );
    }

    public deleteExternalCustomerMappings(
        supplierId: number,
        externalCustomerMappingId: number
    ): Promise<ApiResult<number>> {
        return safeRequest(
            () =>
                request.delete(
                    `${this.baseUrl}/suppliers/${supplierId}/external-customer-mappings/${externalCustomerMappingId}`
                ),
            () => externalCustomerMappingId
        );
    }
}
